import React from 'react';
import { Button } from '@material-ui/core';
import { config } from '../config';

// Shown while the BluHive migration is in progress.
// Flip to false to hide the banner again.
const SHOW_MIGRATION_BANNER = true;

// Height of the fixed migration banner. The top AppBar is shifted down by this
// amount and the routed page content is offset by the same value so that the
// existing per-page top offsets continue to line up with the bottom of the bar.
// When the banner is hidden the height collapses to 0 so no gap is left behind.
export const MIGRATION_BANNER_HEIGHT = SHOW_MIGRATION_BANNER ? 44 : 0;

const smallButtonStyle: React.CSSProperties = {
    fontSize: 11,
    padding: '1px 8px',
    minWidth: 0,
    minHeight: 0,
    lineHeight: 1.5,
};

function MigrationBanner() {
    if (!SHOW_MIGRATION_BANNER) {
        return null;
    }
    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: MIGRATION_BANNER_HEIGHT,
                zIndex: 1302, // Above the AppBar (modal + 1) so it is always visible
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 12,
                padding: '0 16px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                backgroundColor: '#b71c1c',
                color: '#fff',
            }}>
            <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: 0.2 }}>
                We&apos;re migrating to BluHive. Please start using BluHive now. SwissTech will be decommissioned soon.
                Report any bugs or missing reports.
            </span>
            <Button
                color="default"
                variant="contained"
                size="small"
                href={config.BLUHIVE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={smallButtonStyle}>
                Go to BluHive
            </Button>
            {config.BLUHIVE_PNL_URL && (
                <Button
                    variant="outlined"
                    size="small"
                    href={config.BLUHIVE_PNL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...smallButtonStyle, color: '#fff', borderColor: '#fff' }}>
                    BluHive P&amp;L
                </Button>
            )}
        </div>
    );
}

export default MigrationBanner;
